import { useEffect } from 'react';

type RouteServerErrorHandler = (hasError: boolean) => void;

let activeHandler: RouteServerErrorHandler | null = null;

function setRouteServerErrorHandler(handler: RouteServerErrorHandler | null) {
  activeHandler = handler;
}

export function notifyRouteServerError() {
  activeHandler?.(true);
}

export function useRouteServerErrorRegistration(
  setError: (value: boolean) => void,
) {
  useEffect(() => {
    setRouteServerErrorHandler(setError);
    return () => setRouteServerErrorHandler(null);
  }, [setError]);
}
